<template>
    <div class="person-role-pill">
        <div class="person-picture">
            <img :src="collaboratorProfilePicture" class="img-fluid">
        </div>
        <div class="person-info text-truncate">
            <h6 v-if="!isEmpty(credit.collaborator) && credit.collaborator.id" class="text-truncate">
                {{ credit.collaborator.name }}
            </h6>
            <p v-if="!isEmpty(credit.collaborator_role) && credit.collaborator_role.id">
                {{ credit.collaborator_role.name }}
            </p>
            <p v-else>
                Editor
            </p>
        </div>
    </div>
</template>

<script>

import _isEmpty from "lodash/isEmpty";

export default {
    name: "PersonRolePill",
    props: {
        credit: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            profilePictureFieldName: "profile_picture",
            defaultProfilePicture: require("@assets/img/book-insights/person-placeholder.jpg")
        }
    },
    computed: {
        collaboratorProfilePicture() {
            const profilePicFile = this.credit.collaborator.files.find((file) => {
                return file.field_name === this.profilePictureFieldName;
            });
            return !this.isEmpty(profilePicFile) ? profilePicFile.url : this.defaultProfilePicture;
        }
    },
    methods: {
        isEmpty: _isEmpty
    }
}
</script>

<style lang="scss">
.person-role-pill {
    height: 50px;
    display: flex;
    border-radius: 8px;
    background-color: $medium-gray;
    width: fit-content;
    overflow: hidden;

    .person-picture {
        width: 50px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        flex-shrink: 0;
    }

    .person-info {
        padding: 10px 35px;
        padding-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        h6 {
            color: white;
            font-size: 15px;
            font-weight: 400;
            line-height: 19px;
            margin-bottom: 0;
            padding-left: 2px;
        }

        p {
            color: white !important;
            font-size: 11px !important;
            font-weight: 400 !important;
            line-height: 12px !important;
            margin-bottom: 0 !important;
            padding-left: 2px;
        }
    }
}
</style>
